module.exports = __webpack_public_path__ + "img/vertical_6_1_9006.ef3067d5.png";